export default __webpack_public_path__ + "static/media/comunidadNativaShipetari.8c463efe.jpg";